<template>
  <div class="product-description">
    <div
      v-if="liquid.description"
      class="product-description__text rte"
      v-html="liquid.description"
    />

    <transition-height>
      <div
        v-show="liquid.descriptionReadMore && accordionIsActive"
        class="product-description__text-read-more rte"
        v-html="liquid.descriptionReadMore"
      />
    </transition-height>

    <div class="product-description__info">
      <button
        v-if="liquid.descriptionReadMore"
        class="product-description__info-read-more"
        :class="accordionClasses"
        :aria-label="$string('product.description.read_more')"
        :aria-expanded="accordionIsActive"
        @click="handleReadMoreClick()"
      >
        <span
          v-if="!accordionIsActive"
          class="product-description__info-read-more-wrapper"
        >
          <span v-text="$string('product.description.read_more')" />
          <icon-plus />
        </span>

        <span
          v-else
          class="product-description__info-read-more-wrapper"
        >
          <span v-text="$string('product.description.read_more_close')" />
          <icon-cross />
        </span>
      </button>

      <a
        v-if="showTechSpecLink"
        class="product-description__info-tech-spec"
        :href="techSpecUrl"
      >
        <icon-sun />

        <span v-text="$string('product.description.tech_spec')" />
      </a>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product description (product-description)
 * -----------------------------------------------------------------------------
 * Production description component.
 *
 */
import TransitionHeight from '~async/transition-height/transition-height'
import IconSun from '~icons/misc/sun.svg'
import IconPlus from '~icons/misc/plus.svg'
import IconCross from '~icons/misc/cross.svg'

export default {
  name: 'ProductDescription',

  components: {
    IconSun,
    IconPlus,
    IconCross,
    TransitionHeight,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        descriptionReadMore: '',
      }),
    },
    product: {
      type: [
        Boolean,
        Object,
      ],
      default: false,
    },
    variant: {
      type: [
        Boolean,
        Object,
      ],
      default: false,
    },
  },

  data() {
    return {
      accordionIsActive: false,
    }
  },

  computed: {
    accordionClasses: function() {
      return {
        'is-active': this.accordionIsActive,
      }
    },

    /**
     * Compute whether to show the tech spec link.
     * - Link is hidden for spare parts products.
     * - Link is hidden for gift card products.
     */
    showTechSpecLink() {
      const isSparePart = this.product.tags?.includes('[customer_category_type:Sparepart]')
      const isGiftCard = this.product.giftCard
      const isHiddenByTag = this.product.tags?.includes('hide_tech_specs')

      return !isSparePart && !isGiftCard && !isHiddenByTag
    },

    /**
     * Compute product tech spec URL based on the props
     */
    techSpecUrl() {
      if (!this.product) {
        return null
      }

      if (!this.variant) {
        return `${this.product.url}?view=tech-spec`
      }

      return `${this.product.url}?variant=${this.variant.id}&view=tech-spec`
    },
  },

  methods: {
    handleReadMoreClick() {
      this.accordionIsActive = !this.accordionIsActive
    },
  },
}
</script>

<style lang="scss">
@import './product-description';
</style>

